import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import Button from '../../atoms/Button';
import Notice from '../Notice';
import { useForm } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
import NewPasswordForm, { initialData } from './NewPasswordForm';
const PasswordResetForm = () => {
    const { t } = useTranslation();
    const { data, setData, post, processing, errors, reset, } = useForm(initialData);
    const [errorNotice, setErrorNotice] = useState(null);
    const handleSubmit = (e) => {
        e.preventDefault();
        try {
            post(window.location.href, {
                onSuccess: () => {
                    reset();
                },
            });
        }
        catch (e) {
            setErrorNotice(t('password_reset.default_error_notice'));
        }
    };
    return (_jsxs(_Fragment, { children: [errorNotice && (_jsx(Notice, { type: 'error', text: errorNotice || '', title: 'Fout' })), _jsxs("form", { method: 'post', onSubmit: handleSubmit, "data-testid": "password-reset-form", children: [_jsx(NewPasswordForm, { data: data, setData: setData, errors: errors, processing: processing }), _jsx(Button, { secondary: true, fullWidth: true, textAlign: "center", isLoading: processing, children: t('password_reset.save_password_button') })] })] }));
};
export default PasswordResetForm;
